import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const match = <T, TKey extends string = any>(
  getInputKey: (input: T) => TKey,
  getRawKey: (input: any) => TKey,
  serializerMap: {
    [key in TKey]: Serializer<any>;
  },
): Serializer<T> & SerializerExtensions<T> => ({
  serialize: (input) => {
    const key = getInputKey(input);
    return serializerMap[key].serialize(input);
  },
  deserialize: (raw) => {
    const key = getRawKey(raw);
    return serializerMap[key].deserialize(raw);
  },
  ...serializerExtensions(),
});
